import {QUALITY_CLASSES} from 'appConstants';
import {type QualityGradingModelRow} from 'client';
import {type GenericTableValidator} from 'components/Generic/Table/GenericTableInterfaces';
import {precise} from 'helpers/UnitsFormatHandler';

export const getQualityAdjustedRows = (
  rows: QualityGradingModelRow[],
  divider: number,
  precision = 0,
): QualityGradingModelRow[] => {
  return rows.map((row) => getQualityAdjustedRow(row, divider, precision));
};

export const getQualityAdjustedRow = <
  T extends Pick<QualityGradingModelRow, 'production' | 'ordinary' | 'superior' | 'vrak'>,
>(
  row: T,
  divider: number,
  precision = 0,
) => {
  const preciser = (value: number) => precise(value / divider, precision);
  return {
    ...row,
    production: preciser(row.production),
    vrak: preciser(row.vrak),
    ordinary: preciser(row.ordinary),
    superior: preciser(row.superior),
  };
};

export const getQualityModelTotal = (dataRow: Partial<QualityGradingModelRow>) => {
  return QUALITY_CLASSES.reduce((total, qualityClass) => {
    const value = dataRow[qualityClass];
    if (value !== undefined && isNaN(value)) {
      return total;
    }
    return total + (value ?? 0);
  }, 0);
};

export const qualityModelValidator: GenericTableValidator<QualityGradingModelRow> = (dataRow, dataKey) => {
  const total = getQualityModelTotal(dataRow);
  if (total !== 100 && dataKey === 'total') {
    return false;
  }

  const value = dataRow[dataKey];
  if (dataKey === 'cv' && value && value < 0) {
    return false;
  }

  return true;
};
